<div class="progress-bar-container">
  <h6 [ngClass]="{'hidden': !showTitle}">{{title}}</h6>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  <p [ngClass]="{'hidden': !showDescription}">{{descriptionProgress}}</p>
</div>
